
let React =              require("react");
let ApplicationContext = require("../../../config/ApplicationContext.js");
let ActionButton       = require("./ActionButton.jsx");
let ActionDropdown       = require("./ActionDropdown.jsx");

class CardActionItem extends React.Component {

    constructor() {
        super();

        this.state = {}
        this.toggleShow = this.toggleShow.bind(this);
        this.onBlur = this.onBlur.bind(this);        
    }
    
    toggleShow(addListen = false){
        this.headedShow.classList.toggle("show");
    }

    onBlur(event) {
        this.hideBrother();
    }

    hideBrother(){
        let items = document.querySelectorAll(".cardButton.show, .cardButton .show");
        for (let item of items) {item.classList.remove("show")}
    }


    getAsButton(isDropdown, layout, tooltip, text, resource, action, addedClass){
        var ActionButtonType = ActionButton;
        var className = addedClass || "";
        if(isDropdown){
            ActionButtonType = ActionDropdown
            className = "cardButton__text";
        }
        return (
            <div className={`cardButton ${layout}`} onBlur={this.onBlur}>
                <ActionButtonType
                    {...this.props}
                    text={text}
                    action={action}
                    tooltip={tooltip}
                    gridClass={layout}
                    baseClass="cardButton"
                    addedClass={className}
                    ref={div => this.headedShow = div}/>
            </div>
        );
    }


    getAsIcon(isDropdown, layout, tooltip, iconText, resource, action, addedClass){
        var ActionButtonType = ActionButton;
        if(isDropdown){
            ActionButtonType = ActionDropdown;
        }
        let disabled = "";
        if(this.props.disabled){
            disabled = "disabled";
        }
        return (
            <div className={`cardButton ${layout}`}  onBlur={this.onBlur} onMouseLeave={this.hideBrother}>

                <ActionButtonType
                    {...this.props}
                    baseClass="cardButton"
                    addedClass={`cardButton__icon visibleByHover ${addedClass} ${disabled}`}
                    tooltipPos={"right"}
                    gridClass={layout}
                    ref={div => this.headedShow = div}
                    text={iconText}
                    action={action}
                />
            </div>
        )
    }
    

    render() {   
        const {
            resource, 
            layout,
            text,
            iconText = this.props.text,
            action,
            tooltip = false,
            addedClass = "", // right now added class will only work when simple button, not when dropdown button or icon
            buttonOnly=false
        } = this.props;

        let isDropdown = false;
        if(typeof action === 'object'){
            isDropdown = true;
        }

        if(layout == "list" || buttonOnly) {
            return this.getAsButton(isDropdown, layout, tooltip, text, resource, action, addedClass);
        }
        else if(layout == "grid"){
            return this.getAsIcon(isDropdown, layout, tooltip, iconText, resource, action, addedClass);

        } else {
            return "";
        }

    }

}

module.exports = CardActionItem;
